import React, { useState } from 'react';
import { Link, Navigate, useNavigate, useParams } from 'react-router-dom';
import { ArrowLeftIcon, MailIcon, PhoneIcon, Trash2Icon } from 'lucide-react';
import { Button, LinkButton, buttonClasses } from '../../components/ui/Button';
import { TextField } from '../../components/ui/Field';
import { StatusBadge } from '../../components/admin/StatusBadge';
import { useAdminData } from '../../contexts/AdminDataContext';
import { formatDate, telHref } from '../../utils/format';
export function CustomerDetail() {
  const {
    customerId
  } = useParams();
  const navigate = useNavigate();
  const {
    customers,
    casesForCustomer,
    updateCustomer,
    deleteCustomer
  } = useAdminData();
  const customer = customers.find(entry => entry.id === customerId);
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(customer);
  if (!customer) return <Navigate to="/admin/kunder" replace data-id="element-436" data-mp="217bpyivtgphh" />;
  const list = [...casesForCustomer(customer.id)].sort((a, b) => b.createdAt.localeCompare(a.createdAt));
  return <div className="px-5 py-7 md:px-8 md:py-10" data-id="element-437" data-mp="2v5hr3tlhhyoz">
      <Link to="/admin/kunder" className="inline-flex items-center gap-2 text-sm text-ink-muted transition-colors duration-200 ease-smooth hover:text-ink" data-id="element-438" data-mp="2r57l4gxoz8a4">
        <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-439" data-mp="352w5zorreff6" />
        Kunder
      </Link>

      <div className="mt-4 flex flex-wrap items-start justify-between gap-4" data-id="element-440" data-mp="303t247nimf8s">
        <h1 className="font-display text-[clamp(1.8rem,5vw,2.5rem)] font-bold leading-[1.05] tracking-tight text-ink" data-id="element-441" data-mp="2cguoriuoznf3">
          {customer.name}
        </h1>
        <button type="button" onClick={() => {
        if (window.confirm(`Slet ${customer.name}? Kundens sager slettes også. Handlingen kan ikke fortrydes.`)) {
          deleteCustomer(customer.id);
          navigate('/admin/kunder');
        }
      }} className="inline-flex h-9 items-center gap-2 rounded-full border border-line px-3.5 text-sm text-ink-soft transition-colors duration-200 ease-smooth hover:border-ink/30 hover:text-ink" data-id="element-442" data-mp="2m6mmgly38wns">
          <Trash2Icon className="h-4 w-4" aria-hidden="true" data-id="element-443" data-mp="3tpynpd8gfp34" />
          Slet kunde
        </button>
      </div>

      <div className="mt-6 grid gap-5 lg:grid-cols-[0.7fr_1.3fr]" data-id="element-444" data-mp="2frplgnro8yj">
        <section className="rounded-card border border-line bg-white p-6" data-id="element-445" data-mp="6eharvf1qusq">
          <div className="flex items-center justify-between gap-3" data-id="element-446" data-mp="35v5qexacg0ug">
            <h2 className="text-xs font-semibold uppercase tracking-wider text-ink-muted" data-id="element-447" data-mp="3asxh5nz95gx2">
              Kundeoplysninger
            </h2>
            {!editing && <button type="button" onClick={() => {
            setDraft(customer);
            setEditing(true);
          }} className="text-sm font-medium text-accent hover:text-accent-deep" data-id="element-448" data-mp="3ewww424vw7ob">
                Rediger
              </button>}
          </div>

          {editing && draft ? <form className="mt-4 space-y-4" onSubmit={event => {
          event.preventDefault();
          updateCustomer(customer.id, draft);
          setEditing(false);
        }} data-id="element-449" data-mp="19735iuwwf6og">
              <TextField id="kd-navn" label="Navn" required value={draft.name} onChange={event => setDraft({
            ...draft,
            name: event.target.value
          })} data-id="element-450" data-mp="vgq0p1fb083c" />
              <TextField id="kd-tlf" label="Telefon" type="tel" value={draft.phone} onChange={event => setDraft({
            ...draft,
            phone: event.target.value
          })} data-id="element-451" data-mp="lgfq7oknlerv" />
              <TextField id="kd-mail" label="E-mail" type="email" value={draft.email} onChange={event => setDraft({
            ...draft,
            email: event.target.value
          })} data-id="element-452" data-mp="2axgr6ltic5bx" />
              <TextField id="kd-adresse" label="Adresse" value={draft.address} onChange={event => setDraft({
            ...draft,
            address: event.target.value
          })} data-id="element-453" data-mp="2dzcr8k41a7yo" />
              <TextField id="kd-noter" label="Noter" value={draft.notes} onChange={event => setDraft({
            ...draft,
            notes: event.target.value
          })} data-id="element-454" data-mp="28z6y0zi48deh" />
              <div className="flex gap-3 pt-1" data-id="element-455" data-mp="1zz1zzfytarcz">
                <Button type="submit" size="sm" data-id="element-456" data-mp="200vax7ggjxqs">
                  Gem
                </Button>
                <Button type="button" variant="secondary" size="sm" onClick={() => setEditing(false)} data-id="element-457" data-mp="1l7t6gvrsgluk">
                  Annuller
                </Button>
              </div>
            </form> : <>
              <dl className="mt-4 space-y-3 text-[15px]" data-id="element-458" data-mp="1h815b44q5hz8">
                <div data-id="element-459" data-mp="1h7hm7k3c8njm">
                  <dt className="text-ink-muted" data-id="element-460" data-mp="1ha3rfd2raqyo">Navn</dt>
                  <dd className="mt-0.5 text-ink" data-id="element-461" data-mp="xnaclojc1p3n">{customer.name}</dd>
                </div>
                <div data-id="element-462" data-mp="sofvcr10k8ln">
                  <dt className="text-ink-muted" data-id="element-463" data-mp="soz6now5ryqp">Telefon</dt>
                  <dd className="mt-0.5 text-ink" data-id="element-464" data-mp="16nflk346cvjx">{customer.phone || '—'}</dd>
                </div>
                <div data-id="element-465" data-mp="12lc7d6q4fcuy">
                  <dt className="text-ink-muted" data-id="element-466" data-mp="12ksptr4duqhg">E-mail</dt>
                  <dd className="mt-0.5 break-all text-ink" data-id="element-467" data-mp="1gl3hgwdio93o">{customer.email || '—'}</dd>
                </div>
                <div data-id="element-468" data-mp="1bms7mln81ylg">
                  <dt className="text-ink-muted" data-id="element-469" data-mp="1blh3gkpv6ott">Adresse</dt>
                  <dd className="mt-0.5 text-ink" data-id="element-470" data-mp="1qawsnw9qym7e">{customer.address || '—'}</dd>
                </div>
                <div data-id="element-471" data-mp="1lcbs1vql20if">
                  <dt className="text-ink-muted" data-id="element-472" data-mp="1lbtoee1lck0h">Noter</dt>
                  <dd className="mt-0.5 text-ink" data-id="element-473" data-mp="1lefv6bgnqvhn">{customer.notes || 'Ingen noter.'}</dd>
                </div>
              </dl>
              <div className="mt-6 flex flex-col gap-2 sm:flex-row" data-id="element-474" data-mp="1ud9uwapac1zf">
                <LinkButton href={telHref(customer.phone)} variant="secondary" size="sm" data-id="element-475" data-mp="1uax89k8l13g1">
                  <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-476" data-mp="rxisio5c4gzd" />
                  Ring
                </LinkButton>
                <LinkButton href={`mailto:${customer.email}`} variant="secondary" size="sm" data-id="element-477" data-mp="110a89058tywt">
                  <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-478" data-mp="15qqkwi18pgi4" />
                  Send e-mail
                </LinkButton>
              </div>
            </>}
        </section>

        <section className="rounded-card border border-line bg-white" data-id="element-479" data-mp="1as7hi1coygsw">
          <header className="border-b border-line px-5 py-4" data-id="element-480" data-mp="1fn3cnad85ka8">
            <h2 className="font-display text-lg font-bold tracking-tight text-ink" data-id="element-481" data-mp="1knrfqueq9rkt">Sager</h2>
          </header>
          <ul className="divide-y divide-line" data-id="element-482" data-mp="1ool2vlkcj2cn">
            {list.map(item => <li key={item.id} className="flex flex-wrap items-center justify-between gap-3 px-5 py-4" data-id="element-483" data-mp="3mg5u5ji2cdwh">
                <div className="min-w-0" data-id="element-484" data-mp="3qg7o16hk4317">
                  <p className="text-[15px] text-ink" data-id="element-485" data-mp="3qj25cp59x7qe">
                    <span className="font-medium" data-id="element-486" data-mp="3iyi49ugljrql">Sag #{item.number}</span> – {item.title}
                  </p>
                  <p className="mt-0.5 text-sm text-ink-muted" data-id="element-487" data-mp="3e5yfe1cgla6h">{formatDate(item.plannedDate)}</p>
                </div>
                <div className="flex items-center gap-3" data-id="element-488" data-mp="397wwphiy3cvj">
                  <StatusBadge status={item.status} data-id="element-489" data-mp="356uucrtqekpc" />
                  <Link to={`/admin/sager/${item.id}`} className={buttonClasses('secondary', 'sm')} data-id="element-490" data-mp="353yyra5cw842">
                    Åbn
                  </Link>
                </div>
              </li>)}
            {list.length === 0 && <li className="px-5 py-10 text-center text-sm text-ink-muted" data-id="element-491" data-mp="3sv4ku71w3wmt">
                Ingen sager på denne kunde endnu.
              </li>}
          </ul>
          {list.length > 0 && <div className="border-t border-line px-5 py-4" data-id="element-492" data-mp="2hgr1nfi305d4">
              <p className="text-sm text-ink-muted" data-id="element-493" data-mp="2he4o8z8ievmz">
                {list.length} {list.length === 1 ? 'sag' : 'sager'} i alt på denne kunde.
              </p>
            </div>}
        </section>
      </div>
    </div>;
}